import { render } from "./Homepage.vue?vue&type=template&id=a5ba2ffc&scoped=true&ts=true"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"

import "./Homepage.vue?vue&type=style&index=0&id=a5ba2ffc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ba2ffc"]])

export default __exports__